import type { BomRow } from 'shared/state/types';

export const SEPARATOR = '__sw_hw_separator__';
export const SOLUTION_ROW = 'Solution Price';

export type BomTotals = { software: number; hardware: number; grand: number };

const num = (v: unknown) => {
  const n = Number(v);
  return isFinite(n) ? n : 0;
};

/** Rows carry no category field (see generateBom.jsx), so the software/hardware
 *  split is positional: everything before the separator is software. Hidden rows
 *  (showInUi === false) are skipped: they are the license/support children of a
 *  VDURA Care line and split its cost, so counting them doubled it (CONF-225).
 *  The subtotals are therefore the sum of the rows the table actually shows. */
export function bomTotals(rows: BomRow[] | null | undefined): BomTotals {
  let software = 0;
  let hardware = 0;
  let grand: number | null = null;
  let afterSeparator = false;

  for (const row of rows ?? []) {
    if (!row || !row.item) continue;
    if (row.item === SEPARATOR) { afterSeparator = true; continue; }
    // Only a Solution Price row that actually CARRIES a total pins the grand
    // total: num(undefined) is 0, which would pin it at $0.00 and skip the
    // software + hardware fallback below (classic renders "" for that cell,
    // App.js:1191-1193).
    if (row.item === SOLUTION_ROW) { if (row.totalCost !== undefined) grand = num(row.totalCost); continue; }
    if (row.totalCost === undefined || row.showInUi === false) continue;
    if (afterSeparator) hardware += num(row.totalCost); else software += num(row.totalCost);
  }

  return { software, hardware, grand: grand ?? software + hardware };
}
